<template>
  <v-container fluid>
    <v-alert type="error">
      <span v-if="!user">認証に失敗しました。</span>
      <span v-else>エラーが発生しました。</span>
    </v-alert>
  </v-container>
</template>

<script>
export default {
  name: 'ErrorView',
  computed: {
    user() {
      return this.$store.state.user
    },
  },
}
</script>
